
export default (state = "Newest", action) => {
    if (action.type === 'SORT_BY') {
        return action.payload;
    }

    return state;
}